export const WALLET_CONNECT_ID = "dfd5e097a8c59c5f38ac4dc84d86c160";
